import { isRouteErrorResponse, useRouteError } from 'react-router';
import { NotFoundPage } from './NotFoundPage';
import { ErrorFallback } from './ErrorFallback';

/** `errorElement` of the root route: 404 responses get the 404 page, everything else the fallback. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return <ErrorFallback error={error} />;
}
